{
  "brands": [
    "google",
    "rappi",
    "tripadvisor",
    "menupp",
    "didi-food",
    "didifood",
    "ubereats",
    "ifood",
    "instagram",
    "facebook"
  ],
  "domains": [
    "didiglobal.com",
    "googleusercontent.com",
    "gstatic.com",
    "g.page",
    "goo.gl",
    "fbcdn.net",
    "fb.me",
    "instagr.am",
    "cdninstagram.com",
    "wa.me",
    "bit.ly",
    "tinyurl.com",
    "linktr.ee"
  ],
  "linkOnlyHosts": ["drive.google.com", "docs.google.com", "sites.google.com"]
}
